export enum Civility {
  FEMALE = 'F',
  MALE = 'M',
  NONBINARY = 'X',
}
